<div class="profile-container">
  <div class="text-center img-container">
    <img 
      (click)="editProfileImage()" 
      class="profile-image cursor" 
      src="{{newImage ? newImage : userData?.picturePath}}" 
      onerror="this.src='../../../assets/images/avatar.png'" 
      i18n-alt="@@profileImageAlt" 
      alt="Profile image" 
    >
    <mat-icon 
      fontSet="material-icons-round" 
      (click)="editProfileImage()" 
      color="accent" 
      class="cursor edit-icon" 
      aria-hidden="false" 
      i18n-aria-label="@@editProfileImageIconAriaLabel" 
      aria-label="Edit profile image"
    >edit</mat-icon>
  </div>

  @if (subscriptionType != '' && userData.type !== utils.userTypes.DistributorChild && userData.type !== utils.userTypes.ManufacturerChild) {
    <div class="text-center pb-16">
      <span i18n="@@subscriptionsLabel">Subscriptions</span>: {{userData.promotionCodeCount}} | Used: {{usedCount}} | Plan: {{subscriptionType}}
    </div>
  }

  <form [formGroup]="profileForm">
    <div class="d-flex">
      <div class="form-group flex-grow">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label i18n="@@firstNameLabel">First name</mat-label>
          <input data-testid="profile_first_name" matInput id="first_name" i18n-placeholder="@@firstNamePlaceholder" placeholder="First name" name="first_name" formControlName="first_name" required />
          <mat-error>
            @if (!profileForm.get('first_name').valid && profileForm.get('first_name').touched) {
              @if (profileForm.get('first_name').errors && profileForm.get('first_name').errors['required'] || profileForm.get('first_name').hasError('whitespace')) {
                <span i18n="@@inValidRequiredField">This field is required</span>
              }
            }
          </mat-error>
        </mat-form-field>
      </div>

      <div class="space"></div>

      <div class="form-group flex-grow">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label i18n="@@lastNameLabel">Last name</mat-label>
          <input data-testid="profile_last_name" matInput id="last_name" placeholder="Last name" i18n-placeholder="@@lastNamePlaceholder" name="last_name" formControlName="last_name" required />
          <mat-error>
            @if (!profileForm.get('last_name').valid && profileForm.get('last_name').touched) {
              @if (profileForm.get('last_name').errors && profileForm.get('last_name').errors['required'] || profileForm.get('last_name').hasError('whitespace')) {
                <span i18n="@@inValidRequiredField">This field is required</span>
              }
            }
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@titleLabel">Title</mat-label>
        <input data-testid="profile_title" matInput id="title" placeholder="Title" i18n-placeholder="@@titlePlaceholder" name="title" formControlName="title" required />
        <mat-error>
          @if (!profileForm.get('title').valid && profileForm.get('title').touched) {
            @if (profileForm.get('title').errors && profileForm.get('title').errors['required'] || profileForm.get('title').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@emailLabel">Email</mat-label>
        <input data-testid="profile_email" matInput id="email" placeholder="Email" i18n-placeholder="@@emailPlaceholder" name="email" formControlName="email" />
        <mat-error>
          @if (!profileForm.get('email').valid && profileForm.get('email').touched) {
            @if (profileForm.get('email').errors && profileForm.get('email').errors['required'] || profileForm.get('email').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-group d-flex">
      <mat-form-field appearance="outline">
        <mat-label i18n="@@countryCodeLabel">Country code</mat-label>
        <input (keypress)="numberOnly($event)" data-testid="country_code" matInput id="country_code" placeholder="001" i18n-placeholder="@@countryCodePlaceholder" name="country_code" formControlName="country_code" required />
        <mat-error>
          @if (!profileForm.get('country_code').valid && profileForm.get('country_code').touched) {
            @if (profileForm.get('country_code').errors && profileForm.get('country_code').errors['required']) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
          @if (profileForm.get('country_code').errors && profileForm.get('country_code').errors['maxlength'] && !profileForm.get('country_code').errors['required']) {
            <span i18n="@@invalid_country_code_format">Maximum 5 digits</span>
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex-grow ml-8" appearance="outline">
        <mat-label i18n="@@phoneNumberLabel">Phone number</mat-label>
        <input (keypress)="numberOnly($event)" data-testid="profile_phone" matInput id="phone_number" placeholder="Phone number" i18n-placeholder="@@phoneNumberPlaceholder" name="phone_number" formControlName="phone_number" required />
        <mat-error>
          @if (!profileForm.get('phone_number').valid && profileForm.get('phone_number').touched) {
            @if (profileForm.get('phone_number').errors && profileForm.get('phone_number').errors['required']) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
          @if (profileForm.get('phone_number').errors && profileForm.get('phone_number').errors['minlength'] && !profileForm.get('phone_number').errors['required']) {
            <span i18n="@@invalid_phone_min_length">Please enter 7 digits minimum</span>
          }
          @if (profileForm.get('phone_number').errors && profileForm.get('phone_number').errors['maxlength'] && !profileForm.get('phone_number').errors['required']) {
            <span i18n="@@invalid_phone_max_length">Please enter 14 digits maximum</span>
          }
        </mat-error>
      </mat-form-field>
    </div>

    <div data-testid="change_password_click" (click)="openChangePassword()" class="form-group cursor">
      <mat-form-field class="w-100 cursor" appearance="outline">
        <mat-label i18n="@@changePasswordLabel">Click here to change password</mat-label>
        <input matInput disabled id="password" name="password" />
      </mat-form-field>
    </div>

    <div class="profile-button">
      <button i18n="@@saveChanges" data-testid="profile_save_button" mat-raised-button color="primary" (click)="onSubmit()">Save Changes</button>
    </div>
  </form>
</div>
